/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import SubscriptionLanguageModel from 'cio/models/subscription-language';
import { getLocaleByCode } from 'cio/utils/languages';
import { FlyMouseEvent } from '@customerio/fly-components/types/fly-components/events';

interface ConfirmDeleteArgs {
  languages: SubscriptionLanguageModel[];
  onDelete: (evt: FlyMouseEvent<HTMLButtonElement>) => unknown;
  onClose: (evt: FlyMouseEvent<HTMLButtonElement>) => unknown;
}

export default class ConfirmDeleteModal extends Component<ConfirmDeleteArgs> {
  get languageName() {
    if (this.args.languages.length !== 1) {
      return null;
    }

    return getLocaleByCode(this.args.languages[0].id)?.name;
  }
}
